import './MerchantInfoCard.less';

const MerchantInfoCard = ({
  label = '',
  value = '',
  labelTooltip = '',
  ...props
}) => {
  return (
    <div className="br-merchant-info-card">
      <div className="br-merchant-info-card__header">
        <span className="br-merchant-info-card__header-label">{label}</span>

        {labelTooltip && labelTooltip}
      </div>

      <span className="br-merchant-info-card__value">{value}</span>
    </div>
  );
};

export default MerchantInfoCard;
